import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGeoCoords, IGeoLocationState } from 'types/previewCampaign';

// Toạ độ được lấy một lần ở màn bắt đầu khảo sát rồi dùng lại lúc gửi câu trả lời.
// Slice riêng vì cả 3 luồng (survey, page-logic, targeted) đều cần, mỗi luồng
// lại đọc một slice preview khác nhau.
const initialState: IGeoLocationState = {
    coords: null,
};

const geoLocationSlice = createSlice({
    name: 'geoLocation',
    initialState,
    reducers: {
        setGeoLocation: (state, action: PayloadAction<IGeoCoords>) => {
            state.coords = action.payload;
        },
        resetGeoLocation: (state) => {
            state.coords = null;
        },
    },
});

export const { setGeoLocation, resetGeoLocation } = geoLocationSlice.actions;

export default geoLocationSlice.reducer;
